import { QuickStartStatus } from '../enums/quickStartStatus'

export const isQuickStartSkipped = (status: QuickStartStatus | undefined): status is QuickStartStatus =>
  status === QuickStartStatus.Skipped
